import { Vector2 } from "three";

class Config {
    constructor() {
        // this.assets = process.env.PUBLIC_URL + "/assets";
        this.assets = "assets";
        this.scoreHeaderCoef = 8; // score value scale
        this.playersNumber = 5;  //initial players in the progress bar
        this.cadreP1Color = "#FFCA44";
        this.cadreP2Color = "#62ddfc";
        this.currentleaderboard = [];
        this.leaderboardInfos = [];
        this.challengers = [];
        this.profilesScoreBarStep = 1000;
        this.view = { x: 608, y: 1080 };
        this.mouse = { x: 0, y: 0 };
        this.scoreRangeMin = 500;
        this.scoreRangeMax = 999;
        this.changeSkinReady = true;
        this.beatenOpponent = "";
    }
}

export default new Config();